module.exports = __webpack_public_path__ + "img/illustration-createAccount.8336d65d.svg";